import { useMsal } from "@azure/msal-react";

const LogOut = () => {
    const { instance } = useMsal();
    return (
        <div style={{ textAlign: 'center' }}>
            <span onClick={() => { instance.logoutRedirect(); }} id="logout" className="ds-text-primary ds-font-medium ds-cursor-pointer" style={{ fontSize: '15px' }}>
                Log Out
            </span>
        </div>
    )
}
export default LogOut;